import React from 'react'
import { ReactComponent as FemaleSelected } from '../../assets/gender/female-selected.svg'
import { ReactComponent as FemaleUnselected } from '../../assets/gender/female-unselected.svg'
import { ReactComponent as MaleUnselected } from '../../assets/gender/male-unselected.svg'
import { ReactComponent as MaleSelected } from '../../assets/gender/male-selected.svg'
import './gender.less'

interface Props {
  setGender: (value: string) => void
  gender: string
  isError: boolean
}

const Gender: React.FC<Props> = ({ gender, setGender, isError }: Props) => {
  return (
    <div className="gender">
      <div className={isError ? 'person female error' : 'person female'} onClick={() => setGender('F')}>
        {gender === 'F' ? <FemaleSelected /> : <FemaleUnselected />}
      </div>
      <div className={isError ? 'person male error' : 'person male'} onClick={() => setGender('M')}>
        {gender === 'M' ? <MaleSelected /> : <MaleUnselected />}
      </div>
    </div>
  )
}
export default Gender
